import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-logo',
  templateUrl: './brand-logo.component.html',
  styleUrls: [],
  standalone: true,
})
export class BrandLogoComponent {}
